import { configureStore } from '@reduxjs/toolkit'

import currentUserReducer from '../reducers/currentUserReducer';
import navigationReducer from '../reducers/navigationReducer';
import openingReducer from '../reducers/openings/openingReducer';
import openingCopyButtonReducer from '../reducers/openings/openingCopyButtonReducer';

export default configureStore({
  reducer: {
    currentUser: currentUserReducer,
    navigation: navigationReducer,
    opening: openingReducer,
    openingCopyButton: openingCopyButtonReducer,
  }
})
